import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/constants/api-constants';
import { ServiceDueButtonDataModel, TripItem } from 'src/app/model';
import { GeneralService } from 'src/app/services/general.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from 'src/app/shared/services';
import { OptimizationSummaryComponent } from '../entities/entities-profile/pop-overs/optimization-summary/optimization-summary.component';
import { IceOptimizationSummaryComponent } from '../entities/entities-profile/pop-overs/ice-optimization-summary/ice-optimization-summary.component';

@Component({
  selector: 'app-trip-history',
  templateUrl: './trip-history.component.html',
  styleUrls: ['./trip-history.component.scss'],
})
export class TripHistoryComponent implements OnInit, OnDestroy {
  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'F9') {
      this._isMock = !this._isMock;
      this._getTripDetails();
    }
  }

  @Input()
  set date(value: Date | { tripId: string, start: string, end: string }) {
    if (value) {
      this._date = value;
      if (this._sharedService?.getConfiguration('tenantGenericConfig')?.tripHistoryProfilingBasedOn !== 'tripId') {
        let filterDate = this._generalService.formatDate(this.date, 'MMM d');
        this.filterDate =
          filterDate === this._datePipe.transform(new Date(), 'MMM d')
            ? ''
            : filterDate;
      }
      this._getTripDetails();
      this._activeAlertsCountData();
    }
  }
  get date() {
    return this._date;
  }

  @Input()
  set aggregateDate(value: { from: Date; to: Date }) {
    if (value) {
      this._aggregateDate = value;
      this._getTripDetails();
      this._activeAlertsCountData();
    }
  }
  get aggregateDate() {
    return this._aggregateDate;
  }

  @Input() entityId: any;
  @Input() pageType: string;
  @Input() entityName: string;
  @Input() tripName: string;
  @Input() tripId: string;
  @Input() isTripSelected: boolean = false;
  @Input() isCollapsed: boolean = false;
  @Input() entityDetails: any;
  @Input() insightsAvailable: boolean;
  @Input() type: string;
  @Input() transformedAttributeData: any;

  buttonList: ServiceDueButtonDataModel[] = [
    { name: 'Today', isActive: true },
    // { name: 'This Week', isActive: false },
  ];
  token: any = ApiConstants.blobSasToken;

  // @Output() drawer = new EventEmitter<any>();
  @Output() tripDetailsRequest = new EventEmitter<any>();
  @Output() aiAssistDetails = new EventEmitter<any>();
  @Output() analysisDrawerOpen = new EventEmitter<any>();
  @Output() highlightedTripSegment = new EventEmitter<any>();

  activeAlertsCount: number;
  startLocation: any;
  endLocation: any;
  tripDetails: any;
  tripStartDate: string;
  tripEndDate: string;
  startTime: string;
  endTime: string;
  distanceTravelled: number;
  timeTaken: number;
  filterDate: string;
  geoTraceDate: Date[];
  tripItems: TripItem[] = [];
  showAiAssist: boolean = false;
  tripAssistPlots: [number, number][];
  isAiDrawerOpen = false;
  drawerTitle = 'AI Assist – Trip 0011';
  drawerSubtitle = 'Optimization Summary';
  tripInsightsData: TripItem[] = [];
  summaryData: any;
  mileage: number;
  totalFuelConsumed: number;
  showPrescritiveInsights: boolean = false;

  private _date: Date | { tripId: string, start: string, end: string };
  private _isMock: boolean = false;
  private _filterLists: any[] = [];
  private _tenantConfig: any;
  private _aggregateDate: { from: Date; to: Date };
  private _getAlertsCountSubscription: Subscription;
  private _getTripDetailsSubscription: Subscription;
  private _getLocationSubscription: Subscription;
  private _afterClosedSubscription: Subscription;
  private _tripSegmentSubscription: Subscription;
  private _getInsightsSubscription: Subscription;

  constructor(
    private _entitiesService: EntitiesServiceService,
    private _generalService: GeneralService,
    private _datePipe: DatePipe,
    public _sharedService: ServicecallService,
    private _fb: FormBuilder,
    private route: Router,
    private _dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this._tenantConfig = this._sharedService?.getConfiguration(
      'tenantGenericConfig'
    )
      ? this._sharedService?.getConfiguration('tenantGenericConfig')
      : null;

    if (this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId' && this.tripId && this.type === 'playbackV2') {
      this._getInsights();
    }
  }

  ngOnDestroy(): void {
    this._getTripDetailsSubscription?.unsubscribe();
    this._getAlertsCountSubscription?.unsubscribe();
    this._getLocationSubscription?.unsubscribe();
    this._afterClosedSubscription?.unsubscribe();
    this._tripSegmentSubscription?.unsubscribe();
    this._getInsightsSubscription?.unsubscribe();
  }

  /**
 * Gets trips and open drawer
 */
  getTrips() {
    this.handleTileDetail(this._getTileData());
    this.isCollapsed = true;
    this.showAiAssist = true;
    this.isAiDrawerOpen = true;
    this.loadTripData(); // Refresh data when opening
  }

  switchAnalysisDrawer(openFlag: boolean) {
    this.analysisDrawerOpen.emit(openFlag);
  }


  /**
   * Closes drawer
   */
  closeDrawer(): void {
    this.isCollapsed = false;
    this.showAiAssist = false;
    this.isAiDrawerOpen = false;
    this.tripAssistPlots = null;
    this.aiAssistDetails?.emit({ aiAssist: this.showAiAssist, tripAssistPlots: this.tripAssistPlots });
  }

  /**
   * Gets insights
   */
  private _getInsights() {
    const _reqPayload = {
      type: 'PrescriptiveInsights_TripSegment',
      ...(this.tripId && { tripIds: [this.tripId] })
    };
    this._getInsightsSubscription = this._sharedService
      .getInsight(_reqPayload)
      .subscribe({
        next: (result: any) => {
          this.tripInsightsData = Array.isArray(result) ? [...result] : [];
        },
        error: () => {
          this.tripInsightsData = [];
        },
      });
  }

  /**
 * Loads trip segments data
 */
  private loadTripData(): void {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this._sharedService?.getConfiguration('tenantGenericConfig') ? this._sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this._sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if (this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if (this.date) {
        startTime = this.date?.['start'];
        endTime = this.date?.['end'];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.date ? this._generalService?.getStartEndTimeForSelectedDate(this.date, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    const reqPayload = {
      entityId: this.entityId,
      from: this._datePipe.transform(this.aggregateDate?.from ?? ((!this.date && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.aggregateDate?.to ?? ((!this.date && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      type: "PrescriptiveInsights_TripSegment",
      ...(this.tripId && { tripId: this.tripId })
    }
    this._tripSegmentSubscription = this._sharedService.getTripSegments(reqPayload).subscribe({
      next: (result: any) => {
        this.tripItems = Array.isArray(result) ? [...result]?.sort((a: any, b: any) => new Date(b?.dataFrom || 0).getTime() - new Date(a?.dataFrom || 0).getTime())?.map((item, index, arr) =>
          ({ ...item, tripLabel: 'T' + (arr.length - index)?.toString()?.padStart(4, '0') })) : [];
        const matchedTimestamps = new Set<string>();
        this.tripItems?.forEach(trip => {
          const match = this.getMatchingDate(this.transformedAttributeData, trip.dataTo);
          const segmenttoDataMatch = this.getMatchingDate(this.transformedAttributeData, trip.dataTo);
          if (match?.sourceTimestamp) {
            matchedTimestamps?.add(match.sourceTimestamp);
            const matchedCoordinate = this.transformedAttributeData?.find(item => item.sourceTimestamp === match.sourceTimestamp);
            trip.currentLocation = [matchedCoordinate?.lat, matchedCoordinate?.long];
            trip.segmentStartLocation = { lat: matchedCoordinate?.lat, lng: matchedCoordinate?.long };
          }
          if (segmenttoDataMatch?.sourceTimestamp) {
            const matchedCoordinate = this.transformedAttributeData?.find(item => item.sourceTimestamp === segmenttoDataMatch.sourceTimestamp);
            trip.segmentEndLocation = { lat: matchedCoordinate?.lat, lng: matchedCoordinate?.long };
          }
        });
        const coordArray = this.transformedAttributeData?.filter(item => matchedTimestamps?.has(item.sourceTimestamp))?.map((item: any) => ({ lat: item.lat, lng: item.long }));
        this.tripAssistPlots = [...coordArray];
        this.aiAssistDetails?.emit({ aiAssist: this.showAiAssist, tripAssistPlots: this.tripAssistPlots });
      }, error: () => {
        this.tripItems = [];
      }
    })

  }

  /**
 * Gets matching date using binary search
 * @param dataArray 
 * @param targetTime 
 * @returns matching date 
 */
  getMatchingDate(dataArray: any[], targetTime: string): any {
    const targetMs = Date.parse(targetTime);
    let minIndex = 0, maxIndex = dataArray.length - 1;
    let result = null;

    while (minIndex <= maxIndex) {
      const mid = Math.floor((minIndex + maxIndex) / 2);
      const midTime = Date.parse(dataArray[mid]?.sourceTimestamp);

      if (midTime <= targetMs) {
        result = dataArray[mid];
        minIndex = mid + 1;
      } else {
        maxIndex = mid - 1;
      }
    }

    return result;
  }


  /**
   * Gets trip details
   */
  private _getTripDetails() {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this._sharedService?.getConfiguration(
      'tenantGenericConfig'
    )
      ? this._sharedService?.getConfiguration('tenantGenericConfig')
      : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } =
        this._sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;

    if (this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if (this.date) {
        startTime = this.date?.['start'];
        endTime = this.date?.['end'];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate() ?? [];
      }
    } else {
      if (this.date) {
        [startTime, endTime] = this._generalService?.getStartEndTimeForSelectedDate(
          this.date,
          this._tenantConfig?.tenant,
          this._tenantConfig?.defaultTimeRange
        ) ?? [];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate() ?? [];
      }
    }
    // const [startTime, endTime] = this.date
    //   ? this._generalService?.getStartEndTimeForSelectedDate(
    //       this.date,
    //       this._tenantConfig?.tenant,
    //       this._tenantConfig?.defaultTimeRange
    //     )
    //   : this._generalService?.getStartEndTimeByDate();
    this.geoTraceDate = [
      new Date(
        this._aggregateDate?.from ??
        (!this.date && configStartDate ? configStartDate : startTime)
      ),
      new Date(
        this._aggregateDate?.to ??
        (!this.date && configEndDate ? configEndDate : endTime)
      ),
    ];
    const _reqPayload = {
      entityId: this.entityId,
      siteId: this._sharedService.getSiteId(),
      from: this._datePipe.transform(
        this._aggregateDate?.from ??
        (!this.date && configStartDate ? configStartDate : startTime),
        'yyyy-MM-ddTHH:mm:ssZZ'
      ),
      to: this._datePipe.transform(
        this._aggregateDate?.to ??
        (!this.date && configEndDate ? configEndDate : endTime),
        'yyyy-MM-ddTHH:mm:ssZZ'
      ),
      isMock: this._isMock,
    };
    this._getTripDetailsSubscription = this._entitiesService
      .getEntitySummary(_reqPayload)
      .subscribe({
        next: (result: any) => {
          this.showPrescritiveInsights = false;
          this.startLocation = null;
          this.endLocation = null;
          this.tripDetails = result;
          this.timeTaken = this._sharedService.getConfiguration('tenantGenericConfig')?.timeTakenIn === 'hr' ? (this.tripDetails?.timeTakenInMin * 3600) : (this.tripDetails?.timeTakenInMin * 60); // Converts hr/minute to second
          this.distanceTravelled = this.tripDetails?.distanceTravelled;
          this.mileage = this.tripDetails?.mileage;
          this.totalFuelConsumed = this.tripDetails?.totalFuelConsumed;
          this.startTime = result?.from?.time;
          this.endTime = result?.to?.time;
          this.tripStartDate = this._datePipe.transform(
            result?.from?.time,
            'dd MMM yyyy, hh:mm:ss a'
          );
          this.tripEndDate = this._datePipe.transform(
            result?.to?.time,
            'dd MMM yyyy, hh:mm:ss a'
          );
          if (
            this.tripDetails?.from?.coordinates?.lat &&
            this.tripDetails?.from?.coordinates?.long
          )
            this._tenantConfig?.tenant === 'VOT'
              ? this._getLocationFromCoordinates(
                this.tripDetails?.from?.coordinates?.lat,
                this.tripDetails?.from?.coordinates?.long,
                'startLocation'
              )
              : this._fetchLocation(
                this.tripDetails?.from?.coordinates?.lat,
                this.tripDetails?.from?.coordinates?.long,
                'startLocation'
              );
          if (
            this.tripDetails?.to?.coordinates?.lat &&
            this.tripDetails?.to?.coordinates?.long
          )
            this._tenantConfig?.tenant === 'VOT'
              ? this._getLocationFromCoordinates(
                this.tripDetails?.to?.coordinates?.lat,
                this.tripDetails?.to?.coordinates?.long,
                'endLocation'
              )
              : this._fetchLocation(
                this.tripDetails?.to?.coordinates?.lat,
                this.tripDetails?.to?.coordinates?.long,
                'endLocation'
              );
        },
        error: () => {
          this.tripDetails = null;
        },
      });
  }

  /**
   * Fetchs location
   * @param latitude
   * @param longitude
   * @param locationType
   */
  private _fetchLocation(
    latitude: string,
    longitude: string,
    locationType: string
  ) {
    this._getLocationSubscription = this._sharedService
      ?.getLocationFromCoordinates(latitude, longitude)
      .subscribe({
        next: (location) => {
          this.showPrescritiveInsights = true;
          if (locationType === 'startLocation') this.startLocation = location;
          else this.endLocation = location;
        },
        error: () => {
          this.showPrescritiveInsights = true;
          this.startLocation = null;
          this.endLocation = null;
        },
      });
  }

  /**
   * Gets location from coordinates
   * @param latitude
   * @param longitude
   * @param locationType
   * @returns location from coordinates
   */
  private async _getLocationFromCoordinates(
    latitude: string,
    longitude: string,
    locationType: string
  ): Promise<any> {
    try {
      const response = await fetch(
        `${ApiConstants?.HERE_REVERSE_GEOCODE_URL}?at=${latitude},${longitude}&apiKey=${this._tenantConfig?.hereApiKey}&lang=en-US`
      );
      const data = await response?.json();
      if (locationType === 'startLocation')
        this.startLocation = data?.items?.[0]?.address?.label;
      else this.endLocation = data?.items?.[0]?.address?.label;
      this.showPrescritiveInsights = true;
    } catch (error) {
      console.error('Error in reverse geocoding:', error);
      this.startLocation = null;
      this.endLocation = null;
      this.showPrescritiveInsights = true;
    }
  }

  /**
   * Actives alerts count data
   */
  private _activeAlertsCountData() {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this._sharedService?.getConfiguration(
      'tenantGenericConfig'
    )
      ? this._sharedService?.getConfiguration('tenantGenericConfig')
      : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } =
        this._sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;

    if (this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if (this.date) {
        startTime = this.date?.['start'];
        endTime = this.date?.['end'];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate() ?? [];
      }
    } else {
      if (this.date) {
        [startTime, endTime] = this._generalService?.getStartEndTimeForSelectedDate(
          this.date,
          this._tenantConfig?.tenant,
          this._tenantConfig?.defaultTimeRange
        ) ?? [];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate() ?? [];
      }
    }
    // const [startTime, endTime] = this.date
    //   ? this._generalService?.getStartEndTimeForSelectedDate(
    //       this.date,
    //       this._tenantConfig?.tenant,
    //       this._tenantConfig?.defaultTimeRange
    //     )
    //   : this._generalService?.getStartEndTimeByDate();
    this._filterLists = [{ type: 'Status', value: 'active' }];
    const reqData = {
      filterList: this._filterLists,
      from: this._datePipe.transform(
        this._aggregateDate?.from ??
        (!this.date && configStartDate ? configStartDate : startTime),
        'yyyy-MM-ddTHH:mm:ssZZ'
      ),
      to: this._datePipe.transform(
        this._aggregateDate?.to ??
        (!this.date && configEndDate ? configEndDate : endTime),
        'yyyy-MM-ddTHH:mm:ssZZ'
      ),
      siteId: this._sharedService.getSiteId(),
      entityId: this.entityId,
    };
    this._getAlertsCountSubscription = this._sharedService
      .getAlertsCount(reqData, false)
      .subscribe((result: any) => {
        if (result['status']) {
          const status = result['response']['data'].find(
            (item: any) => item.status
          )?.status;
          if (status) {
            this.activeAlertsCount = status
              ? status.find((item: any) => item.status)?.count
              : undefined;
          }
        } else {
          this._sharedService.toasterService({
            type: 'error',
            msg: result?.response?.message,
          });
        }
      });
  }

  public geoTracePlayback() {
    const queryParams = this._date
      ? new URLSearchParams({
        selectedDate: this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId' ? JSON.stringify({ start: this._date?.['start'], end: this._date?.['end'] }) :
          ((this._date instanceof Date) ? new Date(this._date)?.toISOString() : null),
      }).toString()
      : '';

    const url = queryParams
      ? `/vehicles/profile/${this.entityId}/playback?${queryParams}&tripName=${this.tripName}&tripId=${this.tripId}`
      : `/vehicles/profile/${this.entityId}/playback?tripName=${this.tripName}&tripId=${this.tripId}`;

    this.route.navigateByUrl(url);
  }

  geoTracePlaybackV2() {
    const queryParams = this._date
      ? new URLSearchParams({
        selectedDate: this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId' ? JSON.stringify({ start: this._date?.['start'], end: this._date?.['end'] }) :
          ((this._date instanceof Date) ? new Date(this._date)?.toISOString() : null),
      }).toString()
      : '';

    const url = queryParams
      ? `/vehicles/profile/${this.entityId}/playbackV2?${queryParams}&tripName=${this.tripName}&tripId=${this.tripId}`
      : `/vehicles/profile/${this.entityId}/playbackV2?tripName=${this.tripName}&tripId=${this.tripId}`;

    this.route.navigateByUrl(url);
  }
  openOptimizationSummary() {
    // if (this.pageType === 'geoPlayback') {
    //   this.drawer.emit({ action: 'openDrawer', data: this._getTileData() });
    // } else {
    let dialogRef = this._dialog.open<any>(this.entityDetails?.secondaryDetails?.fuelType === 'EV' ? OptimizationSummaryComponent : IceOptimizationSummaryComponent, {
      width: '60%',
      data: {
        tile1: this._getTileData(),
      },
      disableClose: false,
      panelClass: this.entityDetails?.secondaryDetails?.fuelType !== 'EV' ? 'ice-dialog-no-padding' : undefined
    });
    this._afterClosedSubscription = dialogRef
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          console.log('closed');
        }
      });
    // }
  }

  /**
 * Emits trip detail to Geo trace playback (parent) component
 */
  emitTripDetail() {
    this.tripDetailsRequest?.emit(this._getTileData());
  }

  /**
 * Handles tile detail from Trip History (child) component
 * @param tile 
 */
  handleTileDetail(tile: any) {
    this.summaryData = {
      ...tile,
      selectedDate: this.date,
      aggregateDate: this.aggregateDate,
      tripId: this.tripId,
      entityDetails: this.entityDetails
    };
    this.drawerTitle = `AI Assist – ${this.summaryData?.tripName}`;
  }

  getTags() {
    const tags = [];
    if (this.entityDetails?.category) tags.push(this.entityDetails?.category);
    if (this.entityDetails?.secondaryDetails?.type)
      tags.push(this.entityDetails?.secondaryDetails?.type);
    return tags;
  }

  private _getTileData() {
    const configBasedOnCategory = this._sharedService.getConfigurationBasedOnCategory(this.entityDetails);
    const defaultImage = configBasedOnCategory ? configBasedOnCategory?.defaultImage : this._tenantConfig?.defaultImage;
    const defaultImageVot = this._tenantConfig?.defaultImage ? this._tenantConfig?.defaultImage?.[this.entityDetails?.category] : '';
    return {
      tripName: this.tripName ?? null,
      entityName: this.entityName ?? null,
      tripStartDate: this.tripStartDate ?? null,
      startLocation: this.startLocation ?? null,
      tripEndDate: this.tripEndDate ?? null,
      startTime: this.startTime ?? null,
      endTime: this.endTime ?? null,
      endLocation: this.endLocation ?? null,
      distanceTravelled: this.distanceTravelled ?? null,
      totalFuelConsumed: this.totalFuelConsumed ?? null,
      mileage: this.mileage ?? null,
      timeTaken: this.timeTaken ?? 0,
      avgSpeed: this.tripDetails?.avgSpeed ?? null,
      topSpeed: this.tripDetails?.topSpeed ?? null,
      remainingRange: null,
      tags: this.getTags(),
      imageUrl: this.entityDetails?.image ?? (defaultImageVot ? defaultImageVot + this.token : (defaultImage ? defaultImage + this.token : this._entitiesService.getDefaultImageByCategory(this.entityDetails?.category))),
      entityId: this.entityId,
      tripId: this.tripId,
      selectedDate: this.date
    };
  }

  onTripItemClick(item: TripItem): void {
    const segmenttoDataMatch = this.getMatchingDate(this.transformedAttributeData, item.dataTo);
    let highlightedTripPoint = null;
    if (segmenttoDataMatch?.sourceTimestamp) {
      const matchedCoordinate = this.transformedAttributeData?.find(item => item.sourceTimestamp === segmenttoDataMatch.sourceTimestamp);
      highlightedTripPoint = { lat: matchedCoordinate?.lat, lng: matchedCoordinate?.long };
    }
    this.highlightedTripSegment.emit({ highlightedTripPoint });
  }
}
